/* global Blob */
import React from 'react';
import XLSX from 'xlsx';
import { isEqual } from 'lodash';
import { saveAs } from 'file-saver';
import { Button } from 'react-toolbox/lib/button';

// import { productionQueue } from '~/actions/boxStats';
import { articleMissing, articleDistributor } from '~/actions/statsNew';
import Tag from '~/components/Tag';
import Spinner from '~/components/Spinner';

import style from './widget.scss';

export default class ProductionQueue extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      products: {},
      loading: true,
      expanded: !props.indata.expandable
    };
  }

  componentDidMount() {
    this.fetchArticles(
      this.props.indata.locationIdWarehouses,
      this.props.indata.locationIdContainers
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      !isEqual(this.props.indata.locationIdWarehouses, nextProps.indata.locationIdWarehouses) ||
      !isEqual(this.props.indata.locationIdContainers, nextProps.locationIdContainers) ||
      !isEqual(this.props.indata.distributor, nextProps.distributor)
    ) {
      this.fetchArticles(
        nextProps.indata.locationIdWarehouses,
        nextProps.indata.locationIdContainers
      );
    }
  }

  getProducts() {
    return this.state.products.filter(d => d.type === this.props.indata.orderStatus);
  }

  fetchArticles(locationIdWarehouses, locationIdContainers) {
    const { distributor } = this.props.indata;
    (distributor
      ? articleDistributor(this.context.apiClient, locationIdContainers)
      : articleMissing(this.context.apiClient, locationIdContainers, locationIdWarehouses)
    )
      .then(r =>
        this.setState({
          products: r.data,
          loading: false
        })
      )
      .catch(() => this.setState({ loading: false }));
  }

  export(data) {
    const workbook = {
      SheetNames: ['Data'],
      Sheets: { Data: XLSX.utils.json_to_sheet(data) }
    };
    const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
    const wbout = XLSX.write(workbook, wopts);
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'export.xlsx');
  }

  render() {
    const { loading } = this.state;
    const distributor = !!this.props.indata.distributor;
    return (
      <div className={this.props.className}>
        {this.state.loading && <Spinner />}
        {!this.state.loading && (
          <div
            className={[
              style.productionSection,
              this.state.expanded ? style.expanded : style.expandable
            ].join(' ')}
          >
            <div className={style.header}>
              <h5 className={style.productionTitle}>
                {this.props.indata.title || <span>&nbsp;</span>}
              </h5>
              {/* <Button
                onClick={() => this.export(productIds.map())}
                label="Export .xlsx"
                icon="file_download"
                accent
                raised
                className={style.productionExport}
              /> */}
              <Button
                onClick={() => this.setState({ expanded: true })}
                label="Show all"
                icon="keyboard_arrow_down"
                accent
                raised
                className={style.expand}
              />
            </div>
            <div className={style.products}>
              {!distributor && (
                <table className={style.products}>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th className={style.count}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const { products } = this.state;
                      const productIds = Object.keys(products);
                      return productIds.length > 0
                        ? productIds
                            .sort((a, b) => {
                              return products[b] - products[a];
                            })
                            .map(productId => (
                              <tr
                                key={`productionqueue_${productId}`}
                                className={style.productionRow}
                              >
                                <td className={style.title}>
                                  <Tag id={productId} type="article" />
                                </td>
                                <td className={style.count}>{products[productId]}</td>
                              </tr>
                            ))
                        : !loading && (
                        <tr>
                          <td colSpan="2">No pending products</td>
                        </tr>
                          );
                    })()}
                  </tbody>
                </table>
              )}
              {distributor && (
                <table className={style.products}>
                  <thead>
                    <tr>
                      <th>Invoice ID</th>
                      <th>Lot code</th>
                      <th>Product</th>
                      <th className={style.count}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const { products: customers } = this.state;
                      const customerIds = Object.keys(customers);
                      return customerIds.length > 0
                        ? customerIds.map(customerId =>
                            Object.keys(customers[customerId].orders).map(reference =>
                              Object.keys(customers[customerId].orders[reference]).map(
                                productId => (
                                  <tr
                                    key={`productionqueue_${productId}`}
                                    className={style.productionRow}
                                  >
                                    <td className={style.reference}>
                                      {reference !== 'undefined' && reference}
                                    </td>
                                    <td className={style.lot}>{customers[customerId].lot}</td>
                                    <td className={style.title}>
                                      <Tag id={productId} type="article" />
                                    </td>
                                    <td className={style.count}>
                                      {customers[customerId].orders[reference][productId]}
                                    </td>
                                  </tr>
                                )
                              )
                            )
                          )
                        : !loading && (
                        <tr>
                          <td colSpan="4">No pending products</td>
                        </tr>
                          );
                    })()}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/widgets.new/ProductionQueue/widget.js